module.exports = __webpack_public_path__ + "media/images/favicons/favicon-bdcb6e31b5c34157109944f0920e24ff.ico";